import api from "@helpers/api";

import { URLS } from "@constants/urls";

import { CreatePromotionType } from "@type/HRM/promotion-candidates";

export const createPromotion = (() => {
  return async (data: {
    data: CreatePromotionType;
  }): Promise<{ data: CreatePromotionType }> => {
    return api.post(URLS.CREATE_PROMOTION, { ...data }).then((response) => {
      return { data: response.data.result };
    });
  };
})();

export const getInitiatePromotion = (() => {
  return async (): Promise<{ data: CreatePromotionType }> => {
    return api.post(URLS.CREATE_PROMOTION).then((response) => {
      return { data: response.data.result };
    });
  };
})();
